
<template>
  <div>
    <div class="addKcBtn" @click="showCurse"><i class="el-icon-plus"></i>添加课程</div>

    <el-dialog title="选择购买课程" :visible.sync="dialogBuyVisible" width="989px" :append-to-body="true" @opened="openMonted">
      <el-form :inline="true" :model="formInline" class="demo-form-inline" style="float: right;margin-top: 10px;">
        <el-form-item label="">
          <el-input suffix-icon="el-icon-search" v-model="formInline.cname" placeholder="请输入课程名称"
            style="width: 200px;margin-bottom: 10px;float: right;" clearable>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.itype" placeholder="请选择全部课程类别" clearable>
            <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text" style="width: 100%;">
              <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                :value="item.uniqueCode">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="CurseTable.rows" style="width: 100%" highlight-current-row ref="multipleTable"
        row-key="id" @current-change="handleChange">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="date" label="封面" width="70">
          <template slot-scope="scope">
            <img :src="wjSrc+scope.row.img" style="width: 52px;height: 31px;border-radius: 3px;" />
          </template>
        </el-table-column>
        <el-table-column prop="cname" label="标题" width="280">
        </el-table-column>
        <el-table-column prop="itypeName" label="课程类别">
        </el-table-column>
        <el-table-column prop="allxstime" label="课时" width="50">
        </el-table-column>
        <el-table-column prop="address" label="来源" width="50">
          <template slot-scope="scope">
            {{scope.row.cid=='0'?'购买':'自研'}}
          </template>
        </el-table-column>
        <el-table-column prop="endtime" label="有效期">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;width: 100%;height: 40px;">
        <el-pagination background style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
          :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="CurseTable.total">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogBuyVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAave">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog title="选择自研课程" :visible.sync="dialogVisible" width="989px" :append-to-body="true" @opened="openMonted">
      <el-form :inline="true" :model="formInline" class="demo-form-inline" style="float: right;margin-top: 10px;">
        <el-form-item label="">
          <el-input suffix-icon="el-icon-search" v-model="formInline.cname" placeholder="请输入课程名称"
            style="width: 200px;margin-bottom: 10px;float: right;" clearable>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.itype" placeholder="请选择全部课程类别" clearable>
            <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text" style="width: 100%;">
              <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                :value="item.uniqueCode">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table v-if="flag=='2'" :data="CurseTable.rows" style="width: 100%" highlight-current-row ref="multipleTable"
        row-key="id" @current-change="handleChange">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="date" label="封面" width="70">
          <template slot-scope="scope">
            <img :src="wjSrc+scope.row.img" style="width: 52px;height: 31px;border-radius: 3px;" />
          </template>
        </el-table-column>
        <el-table-column prop="cname" label="标题" width="280">
        </el-table-column>
        <el-table-column prop="itypeName" label="课程类别">
        </el-table-column>
        <el-table-column prop="ks" label="课时" width="50">
        </el-table-column>
        <el-table-column prop="address" label="来源" width="50">
          <template slot-scope="scope">
            {{scope.row.cid=='0'?'购买':'自研'}}
          </template>
        </el-table-column>
        <el-table-column prop="endtime" label="有效期">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
        </el-table-column>
      </el-table>
      <el-table v-else :data="CurseTable.rows" style="width: 100%" @select-all="selectAllCurse"
        @select="selectCurse" height="250" ref="multipleTable" row-key="id" @selection-change="selectChangeCurse">
        <el-table-column type="selection" width="55" :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="date" label="封面" width="70">
          <template slot-scope="scope">
            <img :src="wjSrc+scope.row.img" style="width: 52px;height: 31px;border-radius: 3px;" />
          </template>
        </el-table-column>
        <el-table-column prop="cname" label="标题" width="280">
        </el-table-column>
        <el-table-column prop="itypeName" label="课程类别">
        </el-table-column>
        <el-table-column prop="ks" label="课时" width="50">
        </el-table-column>
        <el-table-column prop="address" label="来源" width="50">
          <template slot-scope="scope">
            {{scope.row.cid=='0'?'购买':'自研'}}
          </template>
        </el-table-column>
        <el-table-column prop="endtime" label="有效期">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;width: 100%;height: 40px;">
        <el-pagination background style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
          :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="CurseTable.total">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'CurseBtn',
    props: ['selectCurseIds', 'options', 'wjSrc', 'currentUser', 'flag'],
    data() {
      return {
        CurseTable: {
          rows: [],
          total: 0
        },
        dialogVisible: false,
        dialogBuyVisible:false,
        formInline: {
          rows: 10,
          page: 1,
          cname: '',
          cid: '',
          itype: '',
          isgq: 1
        },
        selectIdArr: []
      }
    },
    methods: {
      getCurseList: function(flag) {
        var $this = this;
        if (!flag && this.CurseTable.rows.length > 0) {
          return;
        };
        var params = this.formInline;
        var url = '';
        if (this.flag == 2) { //购买
          params.own = this.currentUser.id;
        }else{
          delete params.own;
        }
        params.flag=this.flag;
        this.$axios.get('/kt/productInfo/get2listPage.htm?' + this.$qs.stringify(params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.CurseTable = data;
        });
      },
      selectAllCurse: function(selection, row) {
        var selectIdArr = [];
        var selectRows = [];
        selection.map((item) => {
          selectIdArr.push(item.id);
          selectRows.push(item);
        })
        this.selectIdArr = selectIdArr;
        this.selectRows = selectRows;
      },
      selectCurse: function(selection, row) {
        var selectIdArr = [];
        var selectRows = [];
        selection.map((item) => {
          selectIdArr.push(item.id);
          selectRows.push(item);
        })
        this.selectIdArr = selectIdArr;
        this.selectRows = selectRows;
      },
      handleChange:function(selection){
        this.selectIdArr = [selection.id];
        this.selectRows = [selection];
      },
      selectChangeCurse: function(selection) {},
      showCurse: function() {
        if (!this.flag) {
          this.$message({
            message: '请先选择课程来源',
            type: 'warning',
            offset: 300
          });
        } else {
          if(this.flag=='2'){
            this.dialogBuyVisible=true;
          }else{
            this.dialogVisible = true;
          }
        }
      },
      openMonted: function() {
        if (this.selectCurseIds.length > 0) {
          this.CurseTable.rows.forEach(row => {
            if (this.selectCurseIds.indexOf(row.id) >= 0) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
            } else {
              this.$refs.multipleTable.toggleRowSelection(row, false);
            }
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleAave: function() {
        this.$emit('changeCurse', this.selectIdArr, this.selectRows);
        this.dialogVisible = false;
        this.dialogBuyVisible=false;
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
    },
    created: function() {
      this.$set(this.formInline, 'cid', this.currentUser.cid);
    },
    mounted: function() {

    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getCurseList(1)
        },
        deep: true //true 深度监听
      },
      flag:{ //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getCurseList(1)
        },
        deep: true //true 深度监听
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/CurseBtn.vue